import { EstensaColDef } from "../../../../public_api";

export class DetailItem {
    private _estensaColDef: EstensaColDef;
    private _data: any;

    constructor(estensaColDef: EstensaColDef, data:any) {
        this._estensaColDef = estensaColDef;
        this._data = data;
    }

    get estensaColDef() {
        return this._estensaColDef;
    }

    get value() {
        if (this.estensaColDef.field)
            return this.retrieveValue();
        else if (!!this.estensaColDef.estensaDetails.valueGetter)
            return this.estensaColDef.estensaDetails.valueGetter(this._data)

        return null;    
    }

    private retrieveValue(): any {
        let rowValue = this.getPath();
        if (!!this._estensaColDef.estensaDetails && this._estensaColDef.estensaDetails.valueFormatter) {
            return this._estensaColDef.estensaDetails.valueFormatter.call(rowValue, this._data);
        }
        return rowValue;
    }

    private getPath(): any {
        try {
            return this._estensaColDef.field.split('.').reduce((accumulator, currentField) => accumulator[currentField], this._data);
        }
        catch {
            return null;
        }
    }
}
